export enum Orientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical'
}
